import { Helpers } from '../../helpers';
import { ITesterType } from '../../interfaces/itester-type';
import { Well } from '../well';

export class TesterTypeBase {
  TesterTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Wells_TesterType?: Array<Well> | null;

  constructor(item?: ITesterType) {
    if (item) {

      this.TesterTypeId = item.TesterTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Wells_TesterType = Helpers.createClassArray(Well, item.Wells_TesterType);
    }
  }
}